module.exports = __webpack_public_path__ + "img/google-signup-logo.6c2d767d.png";